import styled from 'styled-components';

export const Background = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: rgba(0,0,0,0.6);
    z-index: 200;
    display: none;

    &.opened {
        display: block;
    }
`;

export const Window = styled.div`
    display: none;
    position: fixed;
    top: calc(50% + 15px);
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 550px;
    height: 400px;
    max-height: 400px;
    background-color: #111;
    border: 1px solid #333;
    z-index: 1000;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.opened {
        display: flex;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    background-color: #333;
    height: 30px;
    width: 100%;
`;

export const HeaderTitle = styled.div`
    padding-left: 5px;
    font-size: 14px;
    text-transform: uppercase;
    color: #fff;
`;

export const ButtonBar = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #333;
    width: 100%;
`;

export const Button = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    padding: 0 15px;
    height: 30px;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    &:not(:last-child) {
        margin-right: 10px;
    }

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }
`;

export const ButtonSpace = styled.div`
    flex: 1;
`;

export const TemplateWrap = styled.div`
    flex: 1;
    width: 100%;
    position: relative;
`;

export const TemplateHeader = styled.div`
    border-bottom: 1px solid #444;
`;

export const TemplateFilter = styled.input`
    background-color: #111;
    border: 1px solid #444;
    height: 30px;
    padding-left: 5px;
    width: calc(100% - 40px);
    margin: 0 0 20px 20px;
    color: #fff;

    &:focus {
        outline: none;
    }
`;

export const TemplateTitle = styled.div`
    width: 100%;
    padding: 20px 20px 10px;
    color: #999;
    font-size: 10px;
    text-transform: uppercase;
`;

export const TemplateList = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 20px;
`;

export const TemplateItem = styled.div`
    border: 1px solid #999;
    background-color: #111;
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    width: calc(50% - 5px);
    margin-bottom: 10px;
    transition: all .4s ease 0s;
    cursor: pointer;

    &.selected {
        border-color: #3cf;
        background-color: #3cf;
        color: #000;
    }

    &:not(.selected):hover {
        border-color: #1ad;
        background-color: #1ad;
        color: #000;
    }

    &:nth-child(odd) {
        margin-right: 10px;
    }
`;

export const TemplateItemData = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

export const TemplateItemIcons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;

const BaseIcon = styled.div`
    width: 25px;
    height: 25px;
    position: relative;
    
    &:before {
        transition: all .4s ease 0s;
        color: #777;
        font-size: 24px;
        content: '\\F1398';
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ${TemplateItem}.selected &:before,
    ${TemplateItem}:hover &:before {
        color: #000;
    }
`;

export const TemplateIconOwner = styled(BaseIcon)`
    &:before {
        color: #f93;
        content: '\\F01A5';
    }
`;
export const TemplateIconEditor = styled(BaseIcon)`
    &:before {
        color: #090;
        content: '\\F06BC';
    }
`;
export const TemplateIconStaff = styled(BaseIcon)`
    &:before {
        color: #fc0;
        content: '\\F047A';
    }
`;

export const TemplateItemTitle = styled.div`
    color: #ccc;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all .4s ease 0s;

    ${TemplateItem}.selected &,
    ${TemplateItem}:hover & {
        color: #000;
    }
`;

export const TemplateItemCreatedBy = styled.div`
    color: #999;
    margin-top: 10px;
    font-size: 10px;
    transition: all .4s ease 0s;

    ${TemplateItem}.selected &,
    ${TemplateItem}:hover & {
        color: #000;
    }
`;

export const NoResultTemplateList = styled.div`
    width: 100%;
    color: #777;
    font-size: 16px;
    padding: 120px 40px 0;
    width: 100%;
    text-align: center;

    &:before {
        color: #777;
        font-size: 100px;
        content: '\\F1398';
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const EmptyTemplateList = styled.div`
    width: 100%;
    font-size: 16px;
    color: #777;
    width: 100%;
    padding: 120px 40px 0;
    text-align: center;

    &:before {
        color: #777;
        font-size: 100px;
        content: '\\F0349';
        font-family: "Material Design Icons";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const ConfirmMessage = styled.div`
    height: 100%;
    padding: 0 20px;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;